import * as React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import { Typography } from '@mui/material';
import Service from '../../util/Service';
import HtmlContent from '../util/HtmlContent';


export default function PaginaHtmlDinamica(props) {
    const {rootPage} = props;
    const navigate = useNavigate();
    const location = useLocation();
    const [wait, setWait] = React.useState(true);
    const [pagina, setPagina] = React.useState();

    React.useEffect(()=>{
        if( rootPage && !pagina ){
            buscaPagina(rootPage.nome);
        }else{
            const path = location.pathname.split("/").slice(1);
            if (!path) return false;
            const p = path[path.length - 1];            
            buscaPagina(p);
        }
    }, [location])

    function buscaPagina(p) {        
        setWait(true);
        Service.FETCH("/api/paginaDinamica/buscaPorNome/" + p+ window.location.search).then(r => {            
            setPagina( r );
            setWait(false)
        }).catch(erro =>{            
            navigate("/erro", {
                    state: {
                        erro: {
                            status: erro.status,
                            statusText: erro.statusText,
                            url: erro.url
                        },
                        path:location.pathname
                    }
                });
        })
    }

    if (wait ) {
        return (
            <div style={{
                textAlign: 'center', 
                alignItems: 'center', 
                justifyContent: 'center', 
                display: 'flex',
                width: '100vw',
                height: '85vh'
            }}
            >
                <Typography variant="h4">Aguarde!</Typography>
            </div>
        )
    }

    if( !wait && !pagina){
        return (
            <div style={{
                textAlign: 'center', 
                alignItems: 'center', 
                justifyContent: 'center', 
                display: 'flex',
                width: '100vw',
                height: '85vh'
            }}
            >
                <Typography variant="h4">Pagina não encontrada!</Typography>
            </div>
        )
    }
    
    return (
        // <div ref={containerRef} />

        <HtmlContent htmlString={ pagina } />
    );
    
}